import { INIT_DASHBOARD } from '../../../common/navigation/navigation.actions.types';
import { IDS } from '../accreditation-action-id.constants';
import {TYPES as ACC_TYPES, TYPES} from "../accreditation-action-type.constants";
import { IDS as SECTIONS_IDS} from '../requirements-assessment/requirements-assessment-action-id.constants';
import * as AccreditationActions from '../accreditation.actions';
import get from 'lodash/get';
import pick from 'lodash/pick';
import I18N from '../../../common/utils/util.i18n';

export const accDashboardLocationYear = {
    bindings: {
        onChange: '<',
        hideYear: '@',
    },
    /* @ngInject */
    controller: function ($ngRedux,
                          $scope,
                          $rootScope,
                          $uiRouterGlobals,
                          $timeout,
                          NavigationActions,
                          AuthService,
                          EmployeeService)
    {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.identifier = IDS.accDashboardLocationYear;
            this.isAdmin = AuthService.getUser().type === 'Administrator';
            this.level1Index = 0;
            this.level = 0;
            this.unsubscribe = $ngRedux.connect(({ navigation, accreditation }) => {
                return {
                    ...pick(accreditation.accDashboardLocationYear, [
                        'headOffice',
                        'siteLocation',
                        'year',
                        'schemeId',
                        'schemeCode',
                    ]),
                    sectionsTree: accreditation.sectionsTree,
                    navigationState: navigation.state,
                    navigation,
                    navConfigs: navigation.configs,
                };
            }, {
                ...NavigationActions,
                ...AccreditationActions
            })(this);

            this.unsubscribeSelectCascadeLoaded = $scope.$on('SELECT_CASCADE_SUBJECTS_LOADED', this.onSelectCascadeLoaded.bind(this));
            this.unsubscribeLocationChange = $rootScope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));
            this.unsubscribeCustomBack = $rootScope.$on('CUSTOM_NAVIGATION_BACK', this.back.bind(this));

            switch(this.navigationState){
                case IDS.app_accreditation_dashboard:
                    this.yearSelectEnabled = false;
                    this.resetButtonEnabled = true;
                break;
                case IDS.app_accreditation_scheme_requirements_assessment_dashboard:
                    this.yearSelectEnabled = true;
                    this.resetButtonEnabled = false;
                break;
                default:
                    this.yearSelectEnabled = true;
                    this.resetButtonEnabled = true;
            }

            const setStoredSiteLocation = () => {
                this.isSiteLocationStored = false;
                if (this.siteLocation) {
                    this.initSelectCascade(this.headOffice, this.siteLocation);
                }
            }

            this.isSiteLocationStored = !!this.siteLocation;
            if(this.isSiteLocationStored) {
                setTimeout(setStoredSiteLocation, 400);
            }
        }

        this.onSelectCascadeLoaded = () => {
            if(this.isSiteLocationStored) {
                return;
            }
            if($uiRouterGlobals.params.slo) {
                const siteLocation = $uiRouterGlobals.params.slo;
                EmployeeService.getEmploymentLocations(siteLocation).then(result => {
                    const headOffice = result[0].uuid;
                    this.initSelectCascade(headOffice, siteLocation);
                })
            }
            if($uiRouterGlobals.params.year){
                $ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        year: $uiRouterGlobals.params.year,
                    }
                });
            }
        }

        this.initSelectCascade = (headOffice, siteLocation) =>{
            const user = AuthService.getUser();
            const isSingleSiteUser = user?.parentCount === 1 && user?.parents[0].basicType === 'slo';
            if (isSingleSiteUser) {
                $rootScope.$broadcast('FORCE_SELECT_PARENT', 0, siteLocation, null);
            } else {
                $rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, siteLocation);
            }
        }

        this.filterHeadOffices = (items) => {
            if(!this.schemeHeadOffices || !this.schemeHeadOffices.length || !items.length || items[0].in_subject_basic_type_code !== 'hof') {
                return items;
            }
            else {
                return items.filter(item => this.schemeHeadOffices.includes(item.in_subject_uuid))
            }
        }
        this.filterHeadOffices = this.filterHeadOffices.bind(this);

        this.onLocationChange = (evt, loc) => {
            if(this.isSiteLocationStored) {
                return;
            }
            const subjectType = get(loc,'in_subject_basic_type_code');
            let siteLocation = null;
            switch(subjectType){
                case 'hof':
                    this.headOffice = get(loc, 'in_subject_uuid');
                    this.siteLocation = null;
                break;
                case 'slo':
                    siteLocation = get(loc, 'in_subject_uuid', this.siteLocation);

                    $ngRedux.dispatch({
                        type: TYPES.LOCATION_SEARCH_BAR_CHANGE,
                        accDashboardLocationYear: {
                            headOffice: this.headOffice,
                            siteLocation,
                            year: this.year,
                        }
                    });
                    this.updateTiles(siteLocation, this.year, this.headOffice);
                break;
            }
        };

        this.onYearChange = (evt) => {
            const year = get(evt, 'item.value', this.year);
            this.updateTiles(this.siteLocation, year);
        }

        this.serializeTree = (children, list = []) => {
            children && children.forEach(item => {
                if (item) {
                    list[parseInt(item.id)] = item;
                    this.serializeTree(item.children, list);
                }
            })
            return list;
        };

        this.updateTiles = (siteLocation, year, headOffice = null) => {
            if ((!siteLocation && !headOffice) || !year)
                return

            switch(this.navigationState) {
                case IDS.app_accreditation_dashboard:
                    this.getConfigs('accreditation', siteLocation || headOffice).then(data => {
                        $ngRedux.dispatch({
                            type: INIT_DASHBOARD,
                            dashboard: data.filter(item =>
                                item.order !== 0 // hide abstract tiles
                                && item.url.indexOf('accreditation/scheme/') === -1 // hide tiles under scheme: assessment, mas. doc. list, settings, etc.
                            ),
                            customBackState: null,
                        });
                    })
                break;

                case IDS.app_accreditation_scheme_requirements_assessment_dashboard:
                    const { itemCode, requirement } = $uiRouterGlobals.params;
                    this.fetchFrameworkRequirementsTreeProgress(itemCode, siteLocation || headOffice, year).then(requirements => {
                        let selectedRequirement
                        if(requirement){
                            const list = this.serializeTree(requirements);
                            selectedRequirement = list.find(item => item?.id === parseInt(requirement));
                            if(selectedRequirement.level === 3 || !selectedRequirement.children.length) {
                                selectedRequirement = list.find(item => item && item.id === selectedRequirement.parentId);
                            }
                            this.level = selectedRequirement.level;
                            if(selectedRequirement.level === 2) {
                                const level1Requirement = list.find(item => item?.id === selectedRequirement.parentId);
                                this.level1Index = requirements.indexOf(level1Requirement);
                            }
                        }
                        $ngRedux.dispatch({
                            type: INIT_DASHBOARD,
                            dashboard: mapRequirements(selectedRequirement?.children || requirements),
                            customBackState: selectedRequirement?.level > 1 ? 'app.accreditation.scheme.dashboard' : null,
                        });
                    });
                break;
                default:
                    this.onChange({
                        siteLocation,
                        headOffice,
                        year,
                    });
            }
        }

        const mapRequirements = (data) => {
            return data.map((item, key) => {
                const ctrl = this;
                // const statusName = I18N.translate(`ACCREDITATION.REQUIREMENTS.STATUS.${item.tile_audit_status.toUpperCase()}`) || item.statusName;

                let summary
                if (item.has_overdue_alert || item.has_overdue_warning)
                    summary = undefined
                else if (item.evg_total_count === 0)
                    summary = 'No evidence assigned';
                else if (item.evg_waiting_for_assessment_count > 0)
                    summary = `Waiting for approval ${item.evg_waiting_for_assessment_count} / ${item.evg_total_count}`;
                else if (item.evg_waiting_for_doc_revision_count > 0)
                    summary = `Returned for revision ${item.evg_waiting_for_doc_revision_count} / ${item.evg_total_count}`;
                else if (item.evg_waiting_for_review_count > 0)
                    summary = `Waiting for review ${item.evg_waiting_for_review_count} / ${item.evg_total_count}`;
                else if (item.evg_total_count > 0)
                    summary = `Approved ${item.evg_total_count} / ${item.evg_total_count}`;
                else
                    summary = 'Not scheduled';
                return {
                    color: 'a934e4',
                    icon: 'rco-requirement.svg',
                    selector: `app-accreditation-scheme-sections${item.level === 3 ? '-section' : ''}`,
                    state: item.level === 3 || item.children.length === 0
                        ? SECTIONS_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups
                        : SECTIONS_IDS.app_accreditation_scheme_requirements_assessment,
                    code: $uiRouterGlobals.params.itemCode,
                    title: item.name.length > 60 ? `${item.name.slice(0,60)}...` : item.name,
                    mark: {
                        text: summary || '',
                        icon: !summary || summary === 'Not scheduled' ? '' : 'documents.svg',
                    },
                    critical: item.has_overdue_alert ? 'Assessment Overdue' : undefined,
                    warning: !item.has_overdue_alert && item.has_overdue_warning ? 'Assessment Due Soon' : undefined,
                    ...(item.children.length > 0 ? {
                        onClick: () => {
                            if (this.level === 0) {
                                this.level1Index = key;
                            }
                            this.level++;
                            $ngRedux.dispatch({
                                type: INIT_DASHBOARD,
                                dashboard: mapRequirements(item.children),
                                customBackState: 'app.accreditation.scheme.dashboard',
                            });
                        },
                    } : {
                        onNavigate: () => {
                            $ngRedux.dispatch({
                                type: INIT_DASHBOARD,
                                customBackState: null,
                            });
                            return {
                                requirement:    item.id,
                                slo:        ctrl.siteLocation,
                                hof:        ctrl.headOffice,
                                year:       ctrl.year,
                            };
                        },
                    }),
                };
            });
        };

        this.back = () => {
            const resolve = (data, level = 0) => {
                return level === this.level
                    ? data
                    : resolve(data.children, ++level);
            };
            if (this.level > 0) {
                this.level--;
                const dashboard = this.level === 0
                    ? mapRequirements(this.sectionsTree)
                    : mapRequirements(resolve(this.sectionsTree[this.level1Index]));
                $ngRedux.dispatch({
                    type: INIT_DASHBOARD,
                    dashboard,
                    customBackState: this.level > 0 ? 'app.accreditation.scheme.dashboard' : null,
                });
            }
        };

        this.reset = () => {
            this.level1Index = 0;
            this.level = 0;
            $rootScope.$broadcast('SELECT_CASCADE_RESET', IDS.accDashboardLocationYear);
            $ngRedux.dispatch({ type: TYPES.SCHEME_SECTIONS_RESET });
            $ngRedux.dispatch({ type: INIT_DASHBOARD, dashboard: [], customBackState: null });
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            this.unsubscribe();
            this.unsubscribeLocationChange();
            this.unsubscribeCustomBack();
            this.unsubscribeSelectCascadeLoaded();
        };
    },
    template: `
        <form name="accDashboardLocationYear" novalidate>
            <div layout-gt-xs="row" layout-align="center center">
                <div layout-gt-xs="row">
                    <select-cascade
                        identifier="{{$ctrl.identifier}}"
                        filter-function="$ctrl.filterHeadOffices"
                        purpose="'acc'"
                        scheme="{{scope.$uiRouterGlobals.params.itemCode}}"
                        state-path="siteLocation"
                        preselected="true"
                        behaviour="'selectDefault'"
                        show-single-parent="true"
                        max="slo">
                    </select-cascade>
                </div>
                <input-select
                    flex-gt-sm="10"
                    ng-hide="$ctrl.hideYear === 'true'"
                    ng-if="$ctrl.yearSelectEnabled"
                    label="{{'COMMON.DATE.YEAR' | translate}}"
                    identifier="{{$ctrl.identifier}}"
                    state-module="accreditation"
                    state-path="year"
                    state-data="availableYears"
                    on-change="$ctrl.onYearChange($event)">
                </input-select>
                <div ng-if="$ctrl.siteLocation && $ctrl.resetButtonEnabled" layout="row" layout-align-xs="center center">
                    <md-button class="btnReset" ng-show="$ctrl.isAdmin" ng-click="$ctrl.reset()">Reset</md-button>
                </div>
            </div>
        </form>
    `
};
